import { backendStatus } from "../../../../backend/backend";

export const BatchActionsApi = {
  associate: async (backend, body) => {
    const response = await backend.create(
      `batch_actions/associate_request/batch`,
      getAssociateBody(body)
    );
    return response;
  },
  disassociate: async (backend, body) => {
    const response = await backend.delete(
      `batch_actions/remove_request`,
      getDisassociateBody(body)
    );
    return response;
  },
  update: async (backend, body, addToast, setSelecting) => {
    const response = await backend.create(
      `batch_actions/fw_batch_update`,
      getUpdateBody(body)
    );
     return response;
  },
  updateProfiles: async (backend, body, addToast) => {
    const response = await backend.create(
      `batch_actions/profile`,
      getUpdateProfileBody(body)
    );
    return response;
  },
};

function getAssociateBody(body) {
  return {
    isp: body.isp,
    devices: body.devices.map(({ deviceid, password, username }) => ({
      deviceid,
      password,
      username,
    })),
  };
}

function getDisassociateBody(body) {
  return {
    isp: body.isp,
    devices: body.devices.map((item) => item.deviceid),
  };
}

function getUpdateBody(body) {
  return {
    scope: body.isp,
    devices: body.devices.map(({ deviceid, version }) => ({
      deviceid,
      version,
    })),
  };
}

function getUpdateProfileBody(body) {
  return {
    name: body.profile.name,
    profileid: body.profile.id,
    scope: body.isp,
    status: 1,
    devices: body.devices.map(({ deviceid }) => deviceid),
  };
}

const helpContent = {
  "Aguardando contato":
    "Este dispositivo ainda não conclui sua conexão com o remotize. Assim que ele contactar a plataforma com sucesso, o processo de associação será concluído.",

  "Dispositivo desconhecido":
    "Este erro ocorre quando seu dispositivo ainda não conseguiu realizar contato com a plataforma Remotize. Verifique a conexão do seu dispositivo com a internet.",

  "Dispositivo offline":
    "Dispositivo offline, verifique a conexão com a internet do dispositivo.",

  "Credenciais inválidas": "Credenciais inválidas.",

  "Dispositivo já associado": "Dispositivo já associado.",

  "Fora do padrão": "Dispositivo já está associado ou fora do padrão.",
};
